/**
 * The reader's own time zone, falling back to Pacific if the browser hides it.
 *
 * The detected value is only trusted when it is a zone the backend can resolve:
 * a browser that cannot determine one reports `Etc/Unknown`, which is truthy
 * but rejected by `zoneinfo`, so passing it through would leave Save failing
 * with `Invalid timezone` on a zone the reader never chose.
 */
export function detectedTimezone(): string {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!zone) return 'America/Los_Angeles';
    // Naming it back to Intl rejects placeholders like `Etc/Unknown`, which a
    // browser reports when it cannot determine a zone.
    new Intl.DateTimeFormat('en-US', { timeZone: zone }).format();
    return zone;
  } catch { return 'America/Los_Angeles'; }
}

